import styled, { css } from 'styled-components';
import { siteContainer, container } from '../../styles/layout';
var SiteContentWrapper = styled.div.withConfig({
  displayName: "SiteContentWrapper",
  componentId: "sc-1o3vy8h-0"
})(["", " ", ""], function (_ref) {
  var isFullWidth = _ref.isFullWidth;
  return !isFullWidth && css(["", ""], siteContainer);
}, function (_ref2) {
  var isFullWidth = _ref2.isFullWidth;
  return isFullWidth && css(["", ""], container);
});
export default SiteContentWrapper;